u.ForElement = class extends u.BaseElement {
    /**
     * 
     */
    createdCallback() {
        /**
         * Set defaults
         */
        super.createdCallback();
        this.$forElement = null;
    }
        
    attachedCallback() {
        /**
         * 
         */
        super.attachedCallback();
        const id = this.getAttribute('u-for');
        this.$forElement = document.getElementById(id);
        if (this.$forElement === null) {
            throw `Element ${id} was not found`;
        }
    }
};
